export default __webpack_public_path__ + "static/media/vlogo.91e11322.svg";